<template>
  <div class="company-config-component">
    <div v-if="loading" class="text-center mt-10">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else class="container mt-5">
      <div class="mb-4">
        <strong>{{ $t('company-config.company.label') }}:</strong> {{ companyName }}
      </div>
      <v-tabs v-model="tab">
        <v-tabs-slider color="accent"></v-tabs-slider>
        <v-tab>{{ $t('company-config.survey.title') }}</v-tab>
        <v-tab>{{ $t('company-config.raffle.title') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <survey-config-form
            :company-id="companyId"
            :initial-data="companyConfig?.survey"
            :is-using-global-config="!companyConfig?.surveyHasCustomConfig"
            @config-saved="loadCompanyConfig"
          />
        </v-tab-item>
        <v-tab-item>
          <raffle-config-form
            :company-id="companyId"
            :initial-data="companyConfig?.raffle"
            :is-using-global-config="!companyConfig?.raffleHasCustomConfig"
            :all-categories="allCategories"
            @config-saved="loadCompanyConfig"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import surveyConfigForm from './survey_config_form.vue';
import raffleConfigForm from './raffle_config_form.vue';
import { recognitionService } from '@/services';

export default {
  name: 'CompanyConfigComponent',
  components: {
    surveyConfigForm,
    raffleConfigForm
  },
  props: {
    companyId: {
      type: [String, Number],
      required: true
    },
    companyName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tab: null,
      loading: false,
      allCategories: []
    };
  },
  computed: {
    ...mapGetters('COMPANYCONFIG', ['GET_COMPANY_CONFIG']),
    companyConfig() {
      return this.GET_COMPANY_CONFIG;
    }
  },
  async mounted() {
    await this.loadCompanyConfig();
    await this.loadAllCategories();
  },
  methods: {
    ...mapActions('COMPANYCONFIG', ['ACTION_GET_COMPANY_CONFIG']),
    async loadCompanyConfig() {
      this.loading = true;
      try {
        await this.ACTION_GET_COMPANY_CONFIG(this.companyId);
      } catch (error) {
        console.error('Error loading company config:', error);
      } finally {
        this.loading = false;
      }
    },
    async loadAllCategories() {
      try {
        const idGroup = sessionStorage.getItem("idGroup");
        const idUsuario = sessionStorage.getItem("idUsuario");
        const response = await recognitionService.getCategories(idGroup, this.companyId, idUsuario);
        this.allCategories = response.data.payload || [];
      } catch (error) {
        console.error('Error loading all categories:', error);
        this.allCategories = [];
      }
    }
  }
};
</script>

<style scoped>
.company-config-component {
  min-height: 100vh;
}

.v-tab--active {
  background-color: rgba(0, 0, 0, 0.04);
}

.v-tab:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
</style>
